// @flow

import styled from 'styled-components';
import { colors, fonts } from 'shared/styleguide';

export const Grid = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: 16px;
`;

export const MetricCard = styled.div`
  flex: 1 1 200px;
  border: 1px solid ${colors.paleGrey};
  border-radius: 8px;
  padding: 20px;
  background-color: ${p => (p.highlight ? '#fdf1ef' : colors.paleGreyTwo)};
`;

export const MetricValue = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${p => (p.highlight ? colors.cherry : colors.charcoalGrey)};
`;

export const MetricLabel = styled.div`
  ${fonts.smallRegular};
  color: ${colors.battleshipGrey};
  padding-top: 4px;
`;

export const UpdatedAt = styled.div`
  ${fonts.smallRegular};
  color: ${colors.battleshipGrey};
  padding-top: 16px;
  text-align: right;
`;

export const EmptyState = styled.div`
  ${fonts.bodyRegular};
  color: ${colors.battleshipGrey};
  padding: 32px 0;
  text-align: center;

  a {
    color: ${colors.azul};
  }
`;
